export default {
  // 欢迎信息
  welcome: {
    title: '欢迎回来！',
    greeting: '👋',
  },
  
  // 按钮
  buttons: {
    createCampaign: '新建营销计划',
  },
  
  // 页面标题
  titles: {
    yourCampaign: '您的计划',
    campaignActions: '活动操作',
  },
  
  // 你的活动标签页
  yourCampaignTabs: {
    confirmCollaboration: '确认合作',
    shipProduct: '寄送样品',
    approveDelivery: '确认交付',
    completeCollaboration: '完成合作',
    renewCampaign: '增加预算',
    reviewTimelineExtension: '审核延期申请',
    confirmInviteList: '确认邀请列表',
    influencerAccessSetup: '达人访问设置',
  },

  // 文案
  messages: {
    confirmCollaborationTip:
      '尽快审核申请有助于锁定达人档期并提升合作成功率；反馈拖延会增加达人失联的风险。',
    noPendingActions: '太棒了！当前暂无待办事项～',
  },

  // 充值横幅
  rechargeBanner: {
    depositNow: '立即充值，领取额外广告额度',
    depositWithAmounts: '现在充值 {amount}，可获 {credits} 广告额度',
    depositButton: '立即充值',
  },

  // 帮助区块
  help: {
    title: '我们随时为您提供帮助',
    contact: '联系您的 Aha 支持团队',
    desc: '您可享受我们的专业支持服务。',
  },

  // 资源卡片
  resources: {
    title: '资源',
    cardTitle: 'Aha 创意最佳实践',
    cardDesc:
      '了解在 Aha 上打造更吸引、更有影响力的广告创意的最佳做法。',
  },

  // 报告区块
  report: {
    selectCampaign: '选择营销计划',
  },
  
  // 状态和消息
  status: {
    creating: '创建中…',
  },
  
  // 错误消息
  errors: {
    createCampaignFailed: '创建计划失败，请稍后重试或联系我们',
  },

  // home 通知条
  notification: {
    DMtitle: '消息功能更新',
    DMcontent: '我们收到了您的反馈，并正在升级消息功能，以增强您的沟通体验。消息功能将于10月17日起暂时不可用。一旦达人申请获得批准，您仍然可以通过查看合作详情页面上的邮箱地址与达人联系。我们将尽快通知您，以便您可以使用改进后的版本。感谢您的理解和支持！',
  },
};
